import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { StateContext } from 'globalState';
import * as style from './notification.module.scss';

interface Props {
	showNotification: (value: boolean) => void;
}

const Notification = ({ showNotification }: Props) => {
	const { store } = useContext(StateContext);
	const { isCookiesWarningVisible } = store;
	const setCookiesAccepted = () => {
		localStorage.isNoticeAccepted = true;
	};

	if (localStorage.isNoticeAccepted || isCookiesWarningVisible) return null;
	return (
		<div className={style.wrapper}>
			<div className={style.block}>
				<div className={style.textWrapper}>
					<p className={style.text}>
						<FormattedMessage id="notification.usa" defaultMessage="Please note that the services described in this website are not offered in US and also in any other jurisdiction where such services could be considered restricted. If you choose to access this website, you do so at your own initiative and risk and are responsible for compliance with applicable laws, rules and regulations that may apply to you. The information provided in this website is for informational purposes only. Under no reason information therein should be considered as an intention to provide legal, financial, tax or investment advice. Therefore, you relieve us of any liability for any outcome that may occur due to your use of the website and/ or services."/>
					</p>
				</div>
				<div className={style.buttonWrapper}>
					<button
						className={style.button}
						onClick={() => {
							setCookiesAccepted();
							showNotification(false);
						}}
					>
						<FormattedMessage id="notification.accept" defaultMessage="Accept"/>
					</button>
				</div>
			</div>
		</div>
	);
};

export default Notification;
